import { Field } from '@components/gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { FormFields } from '../types'
import { FormField } from '@generated'

type PhoneFieldProps = {
  isNewApiStructure?: boolean
  fields?: FormFields
}

export const PhoneField: FC<PhoneFieldProps> = ({ isNewApiStructure = false, fields }) => {
  const { t } = useTranslation('forms')

  const getLabel = (): string => {
    if (!isNewApiStructure || !fields) {
      return t('labels.phone')
    }

    const isMandatory = fields.find((f) => f.type === FormField.PhoneNumber)?.mandatory ?? false
    return isMandatory
      ? t('labels.phone')
      : `${t('labels.phone')} - ${t('optional', { ns: 'forms' })}`
  }

  return (
    <Field
      name="phoneNumber"
      label={getLabel()}
      field="input"
      gridColumn="span 12"
      inputMode="tel"
      autoComplete="tel"
    />
  )
}
